import React from 'react';
import { cn } from '@/lib/utils';
import { IconTipB } from '@/components/studio/IconTipB';

/** Studio B's 32 px icon button: the top bar's panel icons and the side panels' header actions. */
export function BarIconB({ label, pressed, onClick, disabled, className, children }: { label: string; pressed?: boolean; onClick: () => void; disabled?: boolean; className?: string; children: React.ReactNode }) {
  return (
    <IconTipB label={label}>
    <button
      type="button"
      aria-label={label}
      aria-pressed={pressed}
      onClick={onClick}
      disabled={disabled}
      className={cn(
        'grid h-8 w-8 place-items-center rounded-[var(--b-radius-control)] transition-colors',
        pressed ? 'bg-b-raised text-b-t1' : 'text-b-t3 hover:bg-b-raised hover:text-b-t1',
        className,
      )}
    >
      {children}
    </button>
    </IconTipB>
  );
}
